module cr.events {
    class eventService  {

        endpoint:string = "https://prod.chronorace.be/api/";

        static $inject = ['$http','$q','$modal','cfg'];

        constructor(private $http,private $q,private $modal,private cfg)
        {
            if (angular.isDefined(cfg.EventApiUrl))
            {
                this.endpoint=cfg.EventApiUrl;
            }
        }

        selectEvent(curEvent?:any):angular.IPromise<any>
        {
            var modal = this.$modal.open({
                //scope: ctrl.$scope,
                templateUrl: 'modules/event/views/eventselectiondialog.html',
                resolve: {
                    //contactDetail: () => (contactId !== 0) ? ctrl.contactService.GetContactDetails(contactId) : null,
                    selectedEvent: () => angular.copy(curEvent)

                },
                controller: eventSelectionCtrl,
                controllerAs: 'eventSelectionCtrl',
                show: true
            });

            return modal.result;
        }

        searchText(search:string): angular.IPromise<any>
        {
            var url = this.endpoint + 'Event/search';

            //var defer = this.$q.defer();
            return this.$http.post(url, { Tokens: [{TokenType:"text",TokenValue:search}] });

/*                .success((data:any, status, headers, config) => {
                    if (data.Success) defer.resolve(data);
                    else defer.reject(data);
                })
                .error((data, status, headers, config) => {
                    defer.reject(data);
                });

            return defer.promise;


            return this.$http.jsonp(this.endpoint+'Event/search'+eventId+'/'+from+'/'+maxEntries+'?callback=JSON_CALLBACK&srch='+encodeURIComponent(search))
                .then((result) => {
                    return result.data;
                });*/
        }

    }
    eventModule.service('eventService', eventService);

}
